import { render, staticRenderFns } from "./AccountingVatListingAmbigousClientsModal.vue?vue&type=template&id=09f0050e&scoped=true"
import script from "./AccountingVatListingAmbigousClientsModal.vue?vue&type=script&lang=ts"
export * from "./AccountingVatListingAmbigousClientsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f0050e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09f0050e')) {
      api.createRecord('09f0050e', component.options)
    } else {
      api.reload('09f0050e', component.options)
    }
    module.hot.accept("./AccountingVatListingAmbigousClientsModal.vue?vue&type=template&id=09f0050e&scoped=true", function () {
      api.rerender('09f0050e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bookkeeping/AccountingVatListingAmbigousClientsModal.vue"
export default component.exports